import Tooltip from "@mui/material/Tooltip";
import Preklad from "../Preklad";

const SiedmaTabulkaConfi = ({
  nevybrateMoznosti,
  vsetkyUdaje,
  slovnik,
  selectedLanguage,
  pismenka,
  kombinaciePismena,
  najdene,
  kombinacieSpolu,
  updateKtoraTab,
  nastavitPismenka,
  konektor,
  poznamka,
  schemy,
  updateSchemy,
}) => {
  const handleHover = (i) => {
    updateKtoraTab(i);
  };

  // KED VIAC AKO 2 SCHEMY -> TAK DAT DO ARRAY
  const schemyToArray = (schema) => {
    // ked je prazdna schema
    if (schema === "-") return "";
    let temp = schema;
    schema = schema
      .replace(/,/g, "")
      .split(" ")
      .filter((e) => e !== "/");
    if (schema.length === 1) return temp;
    else return schema;
  };

  function handleSpecialClick(pismenko, index, riadok) {
    // najst schemu podla indexu "Schéma zapojenia" v nazvoch ked je nested tak najde prvy index
    const norm = (s) => String(s).normalize("NFC").replace(/\s+/g, " ").trim();

    const indexSchemy = vsetkyUdaje.tabulka7.nazvy.findIndex((x) =>
      Array.isArray(x)
        ? x.flat(Infinity).some((y) => norm(y) === norm("Schéma zapojenia"))
        : norm(x) === norm("Schéma zapojenia")
    );

    let schema = riadok[indexSchemy];

    // ROZDELIT DO ARRAY IBA KED VIAC AKO 2, plati iba v jendom riadku
    schema = schemyToArray(schema);

    // ked je ich viac v array ODTUK
    if (pismenka.includes(pismenko) && pismenka.length > 1) {
      // odtuk to pismenko
      nastavitPismenka(pismenka.filter((a) => a !== pismenko));

      if (schema === "") return;
      const odstranit = new Set([].concat(schema));


      
      // odtuk schemy
      const noveSchemy = schemy.map((slot) => {
        if (Array.isArray(slot)) {
          const zvysok = slot.filter((e) => !odstranit.has(e));
          return zvysok.length === 0 ? "" : zvysok;
        }
        return odstranit.has(slot) ? "" : slot;
      });

      // kde prazdne tak zmenit array na string
      if (noveSchemy[noveSchemy.length - 1].length === 0)
        noveSchemy[noveSchemy.length - 1] = "";

      updateSchemy(noveSchemy);
    }
    // ODTUKNUTIE ked iba jedno
    // ked je len jedno pismenko v array
    else if (pismenka.includes(pismenko) && pismenka.length === 1) {
      nastavitPismenka([]);
      updateSchemy((prevArr) => {
        const newArr = [...prevArr];

        newArr[newArr.length - 1] = "";

        return newArr;
      });
    }
    // PRIDANIE dalsieho (ked uz aspon jedno je)
    else {
      nastavitPismenka((prevState) => [...prevState, pismenko]);
      if (schema === "-") return;

      // COM LEN JEDEN IF BLOCK
      if (schema.length > 1) {
        updateSchemy((prevArr) => {
          const newArr = [...prevArr];

          // ze ked je pismeko uz dajake tuknute ale nema ziadnu schemu
          if (newArr[newArr.length - 1] === "") {
            newArr[newArr.length - 1] = schema;
          } else {
            // PRIDAT VSETKY SCHEMY K TYM CO TAM UZ SU
            // UPRAVIT LEBO malo to byt na spajanie v jednom riadku IG ale pri SP2 napr to je problem lebo spaja do jednej 
            const last = newArr.length - 1;
            newArr[last] = [newArr[last], schema];
          }

          return newArr;
        });
      }
    }
  }

  return (
    <div hidden={nevybrateMoznosti} className="siedma_tabulka">
      {/* Nazvy */}
      {/* <div className="table-header" style={{ padding: 0 }}> */}
      <div className="cele_nazvy" style={{ width: "99.9%" }}>
        {vsetkyUdaje.tabulka7.nazvy.map((nazov, i) => {
          if (Array.isArray(nazov)) {
            let pocet_stlpcov = nazov[nazov.length - 1].length;
            return (
              <div key={i} className={"group flex" + pocet_stlpcov}>
                {nazov.map((podnazov, indexPodnazov) => {
                  return (
                    <div key={indexPodnazov} className="row">
                      {podnazov.map((nazovInGroup, nazovInGroupIndex) => {
                        return (
                          <div
                            key={"6" + nazovInGroupIndex}
                            className="element_nazov"
                          >
                            {slovnik.hasOwnProperty(nazovInGroup)
                              ? selectedLanguage === "EN"
                                ? slovnik[nazovInGroup][0]
                                : selectedLanguage === "RU"
                                ? slovnik[nazovInGroup][1]
                                : nazovInGroup
                              : nazovInGroup}
                          </div>
                        );
                      })}
                    </div>
                  );
                })}
              </div>
            );
          }
          return (
            <div className="row">
              <div key={"6" + i} className="element_nazov">
                {slovnik.hasOwnProperty(nazov)
                  ? selectedLanguage === "EN"
                    ? slovnik[nazov][0]
                    : selectedLanguage === "RU"
                    ? slovnik[nazov][1]
                    : nazov
                  : nazov}
              </div>
            </div>
          );
        })}
        <div className="row">
          <div className="element_nazov">↓</div>
        </div>
        <div className="row">
          <div className="element_nazov">↓</div>
        </div>
      </div>

      <div className="mobile_nazvy">
        {vsetkyUdaje.tabulka7.nazvy.length > 1 ? (
          Array.isArray(vsetkyUdaje.tabulka7.nazvy[1]) ? (
            <Preklad
              hodnota={vsetkyUdaje.tabulka7.nazvy[1][0]}
              jazyk={selectedLanguage}
              prekladac={slovnik}
            />
          ) : (
            <Preklad
              hodnota={vsetkyUdaje.tabulka7.nazvy[1]}
              jazyk={selectedLanguage}
              prekladac={slovnik}
            />
          )
        ) : (
          "Názov nie je pridaný"
        )}
      </div>

      {/* Hodnoty */}
      <div className="table-content">
        {" "}
        {vsetkyUdaje.tabulka7.hodnoty.map((hodnota, index) => {
          let indexy = 8;
          let pismenko = hodnota[0];
          return (
            <div
              key={indexy.toString() + index}
              onClick={() => {
                handleSpecialClick(pismenko, index, hodnota);
              }}
              onMouseOver={() => handleHover(indexy)}
              className={
                pismenka && pismenka.includes(pismenko)
                  ? "stisknute table-row-siedma"
                  : "nestisknute table-row-siedma"
              }
            >
              {hodnota.map((hodnotaRiadok, i) => {
                if (
                  hodnotaRiadok !== null &&
                  hodnotaRiadok !== undefined &&
                  typeof hodnotaRiadok === "string" &&
                  hodnotaRiadok.includes(")")
                ) {
                  let rozdelene = hodnotaRiadok.split(" ");
                  let poznamky = rozdelene.filter(
                    (e) => e.includes(")") & !isNaN(e.slice(0, -1))
                  );
                  let text_hodnota = rozdelene
                    .filter((e) => !poznamky.includes(e))
                    .join(" ");
                  return (
                    <div
                      className="siedma_data"
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        gap: "5px",
                      }}
                    >
                      <div>
                        {slovnik
                          ? slovnik.hasOwnProperty(text_hodnota)
                            ? selectedLanguage === "EN"
                              ? slovnik[text_hodnota][0]
                              : selectedLanguage === "RU"
                              ? slovnik[text_hodnota][1]
                              : text_hodnota
                            : text_hodnota
                          : text_hodnota}
                      </div>
                      {poznamky.map((e, i) => {
                        let poznamkaUpravena = "";
                        if (poznamka) {
                          if (poznamka[e.slice(0, -1)]) {
                            poznamkaUpravena = poznamka[e.slice(0, -1)];
                          } else {
                            poznamkaUpravena = "Poznámka nebola nájdena";
                          }
                        } else {
                          poznamkaUpravena = "Poznámka nebola nájdena";
                        }
                        return (
                          <Tooltip
                            title={
                              slovnik
                                ? slovnik.hasOwnProperty(poznamkaUpravena)
                                  ? selectedLanguage === "EN"
                                    ? slovnik[poznamkaUpravena][0]
                                    : selectedLanguage === "RU"
                                    ? slovnik[poznamkaUpravena][1]
                                    : poznamkaUpravena
                                  : poznamkaUpravena
                                : poznamkaUpravena
                            }
                          >
                            <div className="tooltipExtra">{e}</div>
                          </Tooltip>
                        );
                      })}
                    </div>
                  );
                } else if (typeof hodnotaRiadok === "string") {
                  return (
                    <div className="siedma_data">
                      {slovnik.hasOwnProperty(hodnotaRiadok)
                        ? selectedLanguage === "EN"
                          ? slovnik[hodnotaRiadok][0]
                          : selectedLanguage === "RU"
                          ? slovnik[hodnotaRiadok][1]
                          : hodnotaRiadok
                        : hodnotaRiadok}
                    </div>
                  );
                }

                return null;
              })}
            </div>
          );
        })}
        <div
          hidden={
            kombinaciePismena.filter((e) => e.length > 1).length > 0
              ? false
              : true
          }
          style={{ width: "99.9%" }}
        >
          <div className="dov_kombinacie">
            <div id="kombinacie">
              {" "}
              {selectedLanguage === "EN"
                ? "Allowed combination and code: "
                : selectedLanguage === "RU"
                ? "Разрешенные комбинации и код исполнения: "
                : "Dovolené kombinácie a kódy: "}
              {kombinaciePismena.map((elem, indexKombinacii) => {
                if (
                  elem.length > 1 &&
                  najdene &&
                  !najdene[7].includes(kombinacieSpolu[elem])
                ) {
                  if (indexKombinacii === kombinaciePismena.length - 1) {
                    return (
                      elem.split("").join("+") + "=" + kombinacieSpolu[elem]
                    );
                  }
                  return (
                    elem.split("").join("+") +
                    "=" +
                    kombinacieSpolu[elem] +
                    " | "
                  );
                }
                return null;
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SiedmaTabulkaConfi;
